import { EventTypeId } from '../types/eventType';

export const configuredLandingPageEventTypeIds = [
  EventTypeId.SOCCER,
  EventTypeId.TENNIS,
  EventTypeId.BASKETBALL,
  EventTypeId.AMERICAN_FOOTBALL,
  EventTypeId.BASEBALL,
  EventTypeId.ICE_HOCKEY
];
